import formValidation       from 'shared/mixins/form-validation';
import formLabel            from 'shared/mixins/form-label';
import toggleContent        from 'shared/elements/toggle/toggle';
import helperUtilities      from 'shared/mixins/helper-utilities';
import helperPageLock       from 'shared/mixins/helper-page-lock';
import helperA11y           from 'shared/mixins/helper-a11y';
import Promise              from 'promise-polyfill';
import raf                  from 'raf';

/**
 * @module
 * the popup
 */

const selector = '[data-js-popup-shell]';
const popup = function(el, app) {

    const utilities = helperUtilities(app);
    const pageLockHelper = helperPageLock(app);
    const a11yHelper = helperA11y(app);

    // scaffolding and content elements
    const $window = $(window);
    const $document = $(document);
    const $stage = $('[data-js-popup-stage]');
    const $background = $('[data-js-popup-background]');
    const $shell = $('[data-js-popup-shell]');
    const $mask = $('[data-js-popup-mask]');
    const $origArrow = $('[data-js-popup-arrow]');
    const $origClose = $('[data-js-popup-close]');
    let   $content = null; // used later
    let   $button = null; // used later
    let   $clicked = null; // used later
    // defaults
    const widthDefault = 500;
    const gutter = 12;
    const scrollBarGutter = 17;
    const reserveTop = 80;
    // stored status
    let   statusPopping = false;
    let   statusPopped = false;
    let   scrollTop = 0;
    let   viewportWidth = 0;
    let   viewportWidthPrev = viewportWidth;
    let   viewportHeight = 0;
    let   popWidth = null;
    let   popHeight = null;
    let   $buttonParent = null;

    // GO!!
    const init = function() {
        measureEnvironment();
        viewportWidthPrev = viewportWidth;
        registerEvents();
        $stage.addClass('Ge-Popup-Stage--ready');
        // notify other methods that the pop-up is ready
        raf(function tick1() {
            raf(function tick2() {
                app.trigger('PopReady');
            });
        });
    };

    // measure the environment in which the pop-over/modal needs to work
    const measureEnvironment = function() {
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || $window.width();
        viewportHeight = window.innerHeight || document.documentElement.clientHeight || $window.height();
        scrollTop = $window.scrollTop();
    };

    // pop-up events
    const registerEvents = function() {

        // pop-up close events (button, background, JS event)
        $document.on('keypress click','[data-js-popup-close]', killPop);
        $background.on('click', killPop);
        app.on('killAllPops', killPop);

        // kill popovers on window resize (only width, al phone browsers change height in normal scrolling)
        $window.resize(resizeWindow);

        // close all the pop-over on hitting escape key
        $document.on('keyup', escapePop);

        // pop-up activation events (pop-over button, other button or by JS event)
        $document.on('keypress click','[data-js-popover-button]', clickPopOverButton); // popover toggle button inside the popover
        $document.on('keypress click','[data-js-popup-button]', clickPopUpButton); // remote popover/modal activation button
        app.on('popPop', triggerPop);

    };

    // on clicking a pop-over summary button (a button that not only activates the pop-over, but is the anchor for it's positioning)
    const clickPopOverButton = function(ev) {
        
        // when popping a pop-over, remember the button that triggered it, so that when we close the pop-over, we can re-focus that button (a11y)
        $button = $(ev.target);

        // Is this the actual button or a link inside
        // if( !$button[0].hasAttribute( 'data-js-popover-button' ) ){
        //     return
        // }

        ev.preventDefault();

        // mark the pop-over button as active
        $button.addClass('Ge-Popup-Button--active');
        // unselect pop-up text (often happens on accidental doubleclick of button)
        utilities.unselectAllText();
        // activate the popup
        const $popupTarget = $(this).closest('[data-js-popup]');
        popPop($popupTarget,ev);
    };

    // on clicking another button that remotely activates a pop-over or modal.
    // The button needs to have the selector of the popUpTarget as a data attribute [data-popup]
    const clickPopUpButton = function(ev) {

        $button = $(ev.target);

        // Is this the actual button or a link inside
        // if( !$button[0].hasAttribute( 'data-js-popup-button' ) ) {
        //     return
        // }
        ev.preventDefault();

        const popSelector = $(this).attr('data-popup');
        const $popupTarget = $(popSelector);
        if(!$popupTarget.length) {
            console.error('clickPopUpButton error - looking for selector: ' + popSelector);
            return;
        }
        popPop($popupTarget,ev);
    };

    // on sending a JS event to open a popover
    const triggerPop = function(settings) {
        const ev = settings.event;
        const popSelector = settings.popupTarget;
        $button = settings.popupAnchor

        const $popupTarget = ( popSelector instanceof jQuery ? popSelector : $(popSelector) ) ; // the popPop event sends an argument that is a selector of the hidden popUp markup
        popPop( $popupTarget, ev );
    };

    // controller method for opening a pop-over/modal
    const popPop = function($popupTarget,ev) {

        // while initiating a pop-up window, make sure no other events can initiate another one
        if (statusPopping) {
            return;
        }
        statusPopping = true;
        // allow the button to accept clicks again after any transitions have been carried out
        const popPopReadyListener = function() {
            statusPopping = false;
            statusPopped = popType;
            app.off('popComplete', popPopReadyListener);
        }
        app.on('popComplete', popPopReadyListener);
        // is this a pop-over or a modal
        const popType = checkPopType($popupTarget);
        // build the popup
        buildPop($popupTarget, popType);
        // clone the content and fill the pop-up shell with it
        fillPop($popupTarget, popType);
        // enable the content in the pop-up shell (tabindex, aria, validation, etc)
        enablePopContent();
        // figure out the size of the pop-over/modal (returns a promise)
        sizePop($popupTarget, popType).then(function() {
            // lock the page
            lockPage(popType);
            // place the pop on the page, then complete the process by making it visible
            placePop($popupTarget, popType, onCompletePop);
            // focus on the pop-over (a11y)
            a11yHelper.reFocus(ev,$shell.find('[data-js-popup-close]'));
        });
    };

    // is this pop-up a pop-over or a modal?
    const checkPopType = function($popupTarget) {
        if ( !getPopoverButton( $popupTarget ).length && $popupTarget.attr('data-popup-anchor') === undefined) {
            return 'modal';
        }
        return 'popover';
    };

    const buildPop = function($popupTarget, popType) {
        // empty the shell
        $shell.text('');
        // arrow
        if (popType === 'popover') {
            const $arrowCopy = $origArrow.clone();
            $shell.append($arrowCopy);
        }
        // close button (can optionally turn off)
        if ($popupTarget.attr('data-popup-noclose') === undefined) {
            const $closeCopy = $origClose.clone();
            $shell.prepend($closeCopy);
        }
        // mask
        if ($popupTarget.attr('data-popup-nomask') !== undefined) {
            $mask.addClass('Ge-Popup-Mask--no-mask');
        }
    };

    // clone the content and load into the pop-up shell
    const fillPop = function($popupTarget, popType) {
        // content
        $content = $popupTarget.find('[data-js-popup-detail]');
        const $contentCopy = $content.clone();
        $shell.append($contentCopy);
    };

    // measure the size of the pop-up (used for positioning)
    // this is an async process, because slower platforms might not be able to place the element in the visible DOM and measure it within a frame.
    // Don't panic, that really is an edge case these days, but worth catering for,
    const sizePop = function ($popupTarget, popType) {
        return new Promise(function sizePopPromise (resolve, reject) {

            // figure out the width (by default it's the 500px, but a fixed width can be set, or no width, when it just takes the width of the content)
            let   setWidth = widthDefault;
            const setWidthAlt = $popupTarget.attr('data-popup-width');
            const $content = $shell.find('[data-js-popup-detail]');
            // place the pop waaaay off canvas so we can measure it
            let shellCss = {
                'top': '400px',
                'left': '0px'
            };
            // if the width is set as a datatype
            if (setWidthAlt && Number.isInteger(parseInt(setWidthAlt))) {
                shellCss.width = setWidthAlt + 'px';
            } else if (popType) {
                shellCss.width = setWidth + 'px';
            }
            $content.addClass('Ge-Popup-Detail--active');
            $shell.css(shellCss).addClass('Ge-Popup-Shell--active');
            $stage.addClass('Ge-Popup-Stage--active');

            // measure it (why measure width? because we've requested that the popover be a width, but CSS max-width might override that)
            // this is the async bit, as we might need to wait several frames before we get a real measurement (dues to slow platforms)
            let checkPopUpCounter = 0;
            const checkPopUpInDom = function() {
                raf(function tick1() {
                    raf(function tick2() {
                        const popupRect = $shell[0].getBoundingClientRect();
                        popWidth = popupRect.width;
                        if (!setWidthAlt && popWidth < widthDefault) {
                            popWidth = widthDefault;
                        } else if (setWidthAlt && popWidth < parseInt(setWidthAlt)) {
                            popWidth = parseInt(setWidthAlt);
                        }
                        popHeight = popupRect.height;
                        // if the popUp is not measurable yet, wait for the next frame and try again.
                        // (happens on slow platforms - tested on iPads on iOS9, which can take up to 8 frames before the popUp returns a measurement).
                        // Note the edge case fallback - if we do more than 18 frames (arbitrary figure, it's a maximum of 300ms at 16.667ms a frame), exit instead of lopping forever.
                        if (popWidth <= 0 && checkPopUpCounter < 18) {
                            checkPopUpInDom();
                        // the popUp has been successfully measured
                        } else {
                            // reset
                            $stage.removeClass('Ge-Popup-Stage--active');
                            $shell.attr('style','').removeClass('Ge-Popup-Shell--active');
                            $content.removeClass('Ge-Popup-Detail--active');
                            resolve(true);
                        }
                    });
                });
                checkPopUpCounter++;
            };
            checkPopUpInDom();

        });
    };

    // place the pop-up on the screen
    const placePop = function($popupTarget, popType, callback) {
        // size of viewport
        measureEnvironment();
        let shellCss = null;
        // if the popup is a modal
        if (popType === 'modal') {
            shellCss = placePopModal(callback);
        } else {
            shellCss = placePopPopOver($popupTarget, callback);
        }
        // apply the position css to the shell
        $shell.css(shellCss);
        // all done. send the callback
        if (typeof callback === 'function') {
            callback();
        }
    };

    // if the popup is a modal, top, center, done,
    const placePopModal = function(callback) {
        $stage.addClass('Ge-Popup-Stage--modal');
        $mask.addClass('Ge-Popup-Mask--modal');
        $shell.addClass('Ge-Popup-Shell--modal'); // modal class takes care of most things apart from any width set by HTML API data-type
        return {
            'width' : popWidth + 'px'
        };

    };

    const getPopoverButton = function( $popupTarget ){
        return $popupTarget.find('[data-js-popover-button]').addBack('[data-js-popover-button]');
    };

    // if the popup is a popover, we have *a lot* of calculations to do
    const placePopPopOver = function($popupTarget, callback) {

        // elements
        let $anchor = $button || $( $popupTarget.data( 'popup-anchor' ) );

        if ( $anchor.length < 1 ) {
            $anchor = getPopoverButton($popupTarget);
            //$anchor = $popupTarget.find('[data-js-popover-button]');
        }

        const $arrow = $shell.find('[data-js-popup-arrow]');
        // config for whether the popover should appear north or south of the button
        const direction = ($popupTarget.attr('data-popup-direction') ? $popupTarget.attr('data-popup-direction') : false );
        // get custom distance if present, only supported in south, TODO: implement for all directions?
        const customDistanceSouth = $popupTarget.attr('data-popup-distance-s') ? $popupTarget.attr('data-popup-distance-s') : 0 ;
        // the pop-over activation button - we need it's position and dimensions so we can anchor the pop-over to it.
        const rect = $anchor[0].getBoundingClientRect();
        let   top = scrollTop + rect.top + rect.height + parseInt(customDistanceSouth); // by default, assume the placing of the pop-over is south of the button

        let   bottom = null;
        let   left = rect.left + ( rect.width/2 );
        let   boxAdjust = 0;
        let   arrowAdjust = 0;
        // ** HORIZONTAL POSITIONING **
        // on small screens, the popover is "full width"
        if (popWidth + ( gutter * 2 ) >= viewportWidth) {
            popWidth = viewportWidth - ( gutter * 2 );
            arrowAdjust = left - gutter;
            left = gutter;
            arrowAdjust = ( arrowAdjust + 11 >= popWidth ? popWidth - 18 + 'px': arrowAdjust + 'px' );
            $arrow.css({
                'left' : arrowAdjust
            });
        // on big screens, center it horizontally on button, unless that pushes the box off the page
        } else {
            left = rect.left + ( rect.width/2 ) - ( popWidth/2 );
            const leftSide = parseFloat(left);
            const rightSide = leftSide + popWidth + scrollBarGutter;
            // off the right site
            if ( rightSide + gutter > viewportWidth) {
                boxAdjust = rightSide - viewportWidth + gutter;
                left = left - boxAdjust;
                arrowAdjust = -1 * boxAdjust;
            // off the left site
            } else if ( left - gutter < 0) {
                boxAdjust = 0 + gutter - left;
                left = gutter;
                arrowAdjust = boxAdjust;
            }
            $arrow.css({
                'left' : 'calc( 50% - ' + arrowAdjust + 'px )'
            });
        }
        // ** VERTICAL POSITIONING **
        // If the popover is not requested to be south of the button,
        // or is definitely requested to be north,
        // or isn't requested in any direction, but could fit better north than south...
        if (direction !== 'south' // we HAVEN'T forced the direction "south"
            && (
                direction === 'north' // we've forced the direction "north"
                ||
                (
                    rect.top > ( viewportHeight * 0.5 ) && // the anchor button is in the top half of the viewport
                    popHeight < ( rect.top - reserveTop ) && // the popup isn't taller that the space above the button to the reserve dist from the top of the viewport
                    scrollTop + rect.top > 200   // the anchor is not in the first 200px of the viewport (a bit arbitrary, but feels right)
                )
            )
         ) {
            const body = document.body;
            const html = document.documentElement;
            const height = Math.max( body.offsetHeight,
                                             html.clientHeight, html.offsetHeight );
            bottom = height - ( scrollTop + rect.top );
            $shell.addClass('Ge-Popup-Shell--north');
            $arrow.addClass('Ge-Popup-Arrow--north');
            // return the placing
            return {
                'top': 'auto',
                'bottom': bottom + 'px',
                'left': left + 'px',
                'width' : popWidth + 'px'
            };
        // else it's south of the button, remove any northern characteristics
        } else {
            $shell.removeClass('Ge-Popup-Shell--north');
            $arrow.removeClass('Ge-Popup-Arrow--north');
            // return the placing
            return {
                'top': top + 'px',
                'bottom': 'auto',
                'left': left + 'px',
                'width' : popWidth + 'px'
            };
        }
    };

    // after the pop is filled and placed, make the pop visible. Run as a callback, after the pop is placed.
    const onCompletePop = function() {
        $stage.addClass('Ge-Popup-Stage--active');
        $shell.addClass('Ge-Popup-Shell--active Ge-Popup-Shell--animate');
        const $container = $shell.find('[data-js-popup-detail]');
        $container.addClass('Ge-Popup-Detail--active');
        $mask.addClass('Ge-Popup-Mask--active');
        // notify other methods that the pop is ready (defer to next frame to make sure DOM has caught up.)
        raf(function tick1() {
            raf(function tick2() {
                app.trigger('popComplete', {$container });
            });
        });
    };

    // enable the tabindex/content/aria of the content inside the pop-up shell
    const enablePopContent = function() {
        // enable all aria and hidden fields
        a11yHelper.show($shell);
        $shell.find('[data-js-popup-close]').attr('aria-hidden',false);
        // set form validation going
        const $formElements = $shell.find('[name="number"],[name="url"],[name="email"],[name="tel"],[pattern],[required]');
        $.each($formElements, function(index, el) {
            formValidation(el,app);
        });
        // set form labels going
        const $labelElements = $shell.find('.Ge-Label');
        $.each($labelElements, function(index, el) {
            formLabel(el,app);
        });
        // set toggles going
        const $toggleElements = $shell.find('[data-js-toggle]');
        $.each($toggleElements, function(index, el) {
            toggleContent(el,app);
        });
    };

    // optionally lock the page scrolling (by default it's always for modals, never for popovers)
    const lockPage = function(popType) {
        if (popType === 'modal') {
            pageLockHelper.on();
        }
    }

    // kill a pop when the escape key is hit and a pop is open.
    const escapePop = function(ev) {
        if(ev && ev.keyCode == 27){
            killPop(ev);
        }
    };

    // on window resize, kill pop-overs, rather than recalculate all the positioning. This doesn't apply to modals, as they're CSS controlled and don't need any weird specific positioning.
    const resizeWindow = function() {
        if (!statusPopped || statusPopped === 'modal') {
            return false;
        }
        measureEnvironment();
         if(viewportWidth != viewportWidthPrev){
                killPop(false,true);
         }
         viewportWidthPrev = viewportWidth;
    };

    // kill pop-over/modal
    let   killPopTimer1 = false;
    const killPop = function(ev,immediate) {
        // if the window is starting up, don't interupt
        if (statusPopping && !immediate) {
            return;
        }
        // start the process of collspasing by removing all the active states
        $stage.removeClass('Ge-Popup-Stage--active');
        $shell.removeClass('Ge-Popup-Shell--active');
        $mask.removeClass('Ge-Popup-Mask--active');
        if ($button) {
            $button.removeClass('Ge-Popup-Button--active');
        }
        // clean up callback after collapse
        const killPopCleanUp = function () {
            // push out a frame in a double raf to make sure the DOM is settled
            raf(function tick1() {
                raf(function tick2() {
                    $stage.removeClass('Ge-Popup-Stage--modal');
                    $shell.text('').attr('style',false).removeClass('Ge-Popup-Shell--animate Ge-Popup-Shell--modal');
                    $mask.removeClass('Ge-Popup-Mask--modal Ge-Popup-Mask--no-mask');
                    pageLockHelper.off();
                    $button = false;
                    statusPopped = false;
                });
            });
        }
        // no animation collapse
        if (immediate) {
            clearTimeout(killPopTimer1);
            killPopTimer1 = setTimeout(killPopCleanUp,0);
        // animate the collapse
        } else {
            // fade out pop-over
            killPopTimer1 = setTimeout(killPopCleanUp,400);
        }
        // refocus on the parent button
        a11yHelper.reFocus(ev,$button);
    };

    return {
        init: init()
    };
};

popup.selector = selector;

export default popup;
